import CashFlowList from '../../views/CashFlow/CashFlowList';
import CashFlowEdit from '../../views/CashFlow/CashFlowEdit';
import CashFlowCategory from '../../views/CashFlow/CashFlowCategory';
import CashFlowSearch from '../../views/CashFlow/components/CashFlowSearch';

export default [
    {
        path: '/caixa',
        name: 'cashflow.list',
        component: CashFlowList,
        meta: {
            pageTitle: 'Caixa',
            searchBar: CashFlowSearch,
            breadcrumb: [
                { label: 'Caixa' },
            ],
        },
    },
    {
        path: '/caixa/categorias',
        name: 'cashflow-category.list',
        component: CashFlowCategory,
        meta: {
            pageTitle: 'Caixa',
            breadcrumb: [
                { label: 'Caixa' },
            ],
        },
    },
    {
        path: '/caixa/cadastro',
        name: 'cashflow.create',
        component: CashFlowEdit,
        meta: {
            pageTitle: 'Cadastro de Lançamento',
            breadcrumb: [
                { label: 'Caixa', routeName: 'cashflow.list' },
                { label: 'Cadastro de Lançamento' },
            ],
        },
    },
    {
        path: '/caixa/:id',
        name: 'cashflow.edit',
        component: CashFlowEdit,
        meta: {
            pageTitle: 'Edição de Lançamento',
            breadcrumb: [
                { label: 'Caixa', routeName: 'cashflow.list' },
                { label: 'Edição de Lançamento' },
            ],
        },
    },
];
